<template>
  <div class="nav-container">
    <div class="navScrollWrap">
      <el-menu :default-active="$route.path" class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose"
        @select="select" mode="horizontal" :collapse="isCollapse" unique-opened router>
        <!--本地-->
        <template>
          <template v-for="item in items">
            <!--有二级目录-->
            <template v-if="item.children&&item.children.length>0">
              <el-submenu :index="item.index" :key="item.index">
                <!--父菜单-->
                <template slot="title">
                  <i :class="item.icon"></i>
                  <span slot="title">{{item.title}}</span>
                </template>
                <!--子菜单-->
                <!--有三级菜单-->
                <template v-for="(sub, i) in item.children">
                  <el-submenu v-if="sub.children" :key="i" :index="sub.index">
                    <template slot="title"><span slot="title">{{sub.title}}</span></template>
                    <!--四级菜单-->
                    <template v-for="(subChild, k) in sub.children">
                      <el-submenu v-if="subChild.children" :key="k" :index="subChild.index">
                        <template slot="title"><span slot="title">{{subChild.title}}</span></template>
                        <el-menu-item v-for="(lastChild,idx) in subChild.children" :key="idx"
                          :index="lastChild.index">{{lastChild.title}}</el-menu-item>
                      </el-submenu>
                      <el-menu-item v-else :key="subChild.index"
                        :index="subChild.index">{{subChild.title}}</el-menu-item>
                    </template>

                  </el-submenu>
                  <!--无三级菜单-->
                  <el-menu-item :key="sub.index" :index="sub.index" v-else>{{sub.title}}</el-menu-item>
                </template>
                <!--子菜单结束-->
              </el-submenu>
            </template>
            <!--无二级目录-->
            <template v-else>
              <el-menu-item :index="item.index" :key="item.index">
                <i :class="item.icon"></i>
                <span style="line-height: 46px">{{ item.title }}</span>
              </el-menu-item>
            </template>
          </template>
        </template>
      </el-menu>
    </div>
  </div>
</template>

<script>

export default {
  props: [],
  data() {
    return {
      isShowNav: true,
      rows: [],
      items: [
        // {
        //   icon: "",
        //   title:this.$t('el.home'),
        //   index: "/home",
        //   pmShow: true
        // },

        // {
        //   icon: "",
        //   title: this.$t('el.blockchain'),
        //   index: "/blockchain",
        //   pmShow: true,
        //   children: [
        //     {
        //       icon: "",
        //       title:this.$t('el.transactions'),
        //       index: "jy",
        //       pmShow: true,
        //     },
        //     {
        //       icon: "",
        //       title: this.$t('el.pendingTransactions'),
        //       index: "dcljy",
        //       pmShow: true,
        //     }
        //   ]
        // },
      ],
      isCollapse: false
    };
  },
  created() {
    this.getNavInfo()
  },
  mounted() { },
  computed: {},
  methods: {
    getNavInfo() {
      this.items = this.items.filter((node) =>
        this.fn(node, (node) => {
          return node.pmShow;
        })
      )
    },
    fn(node, filter) {
      let res = false;
      if (filter(node)) {
        res = true;
      } else if (node.children instanceof Array) {
        const _data = node.children.filter((node) =>
          this.fn(node, filter)
        );
        node.children = _data;
        if (node.children.length > 0) {
          res = true;
        }
      }
      return res;
    },
    handleOpen(key, keyPath) {
      //        console.log(key, keyPath);
    },
    select(key, keyPath) {
      let breadcrumb = "";
      let arrs = [];
      keyPath.forEach(item => {
        let arr = this.readNodes(this.items, item);
        arrs.push(arr);
      });

      this.$store.commit("getCurrentPage", arrs.join("/"));
    },
    readNodes(nodes, key, arr = []) {
      for (let item of nodes) {
        if (key == item.index) {
          arr.push(item.title);
        }
        if (item.children && item.children.length)
          this.readNodes(item.children, key, arr);
      }
      return arr.join();
    },
    handleClose(key, keyPath) {
      //        console.log(key, keyPath);
    }
  }
};
</script>
<style lang="scss" scoped>
.nav-container {
  display: flex;
  justify-content: center;

  .navScrollWrap {
    ::v-deep .el-menu--horizontal {
      border-bottom: none;
      .el-menu-item.is-active {
        color: #409EFF;
        border-bottom: none;
      }

      .el-menu-item,
      .el-submenu__title {
        height: 50px;
        line-height: 50px;
      }
    }
  }
}
</style>
